export const PRODUCT_CATEGORIES_REQUESTING = "PRODUCT_CATEGORIES_REQUESTING" 
export const PRODUCT_CATEGORIES_REQUEST_SUCCESS = "PRODUCT_CATEGORIES_REQUEST_SUCCESS" 
export const PRODUCT_CATEGORIES_REQUEST_ERROR = "PRODUCT_CATEGORIES_REQUEST_ERROR" 
